'use client'

import { getQueryCacheKey } from '@/helpers/getQueryCacheKey'
import { useSelectedOrgUnitId } from '@/hooks/useSelectedOrgUnitId'

// Reading the cookie also subscribes the caller, so switching organisation re-renders with a new key.
export const useOrgScopedQueryCacheKey = (name: string, query: object): string[] => {
  const selectedOrgUnitId = useSelectedOrgUnitId()

  return getQueryCacheKey(name, query, selectedOrgUnitId)
}
